import { render, staticRenderFns } from "./filter-selector.vue?vue&type=template&id=5c3db4de&"
import script from "./filter-selector.vue.ts?vue&type=script&lang=ts&"
export * from "./filter-selector.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports